// import Vue from 'vue'
import service from './request.js'
// import config from './config';
// let base = config.ApiDomain;
const root = process.env.NODE_ENV === 'production' ? '' : '/api'
//获取token
export const gettoken = params => {
    return service({
        url: root + "/index/gettoken",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//获取产品列表
export const getproduct = params => {
    return service({
        url: root + "/index/getproduct",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//获取线材与包装
export const getxcbz = params => {

    return service({
        url: root + "/index/getxcbz",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//产品信息

export const getpro = params => {

    return service({
        url: root + "/index/getpro",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//获取省市区
export const getregxx = params => {

    return service({
        url: root + "/index/getregxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
export const getregcs = params => {

    return service({
        url: root + "/index/getregcs",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
export const getregqx = params => {

    return service({
        url: root + "/index/getregqx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//订单结算

export const gettjddxx = params => {

    return service({
        url: root + "/index/tjddxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//设计型号
export const getdexh = params => {

    return service({
        url: root + "/prdes/getdexh",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//设计定制
export const tjdexx = params => {

    return service({
        url: root + "/prdes/tjdexx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//壳体面板
export const getktmb = params => {

    return service({
        url: root + "/prdes/getktmb",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//壳体特效
export const getkttx = params => {

    return service({
        url: root + "/prdes/getkttx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//材质面板
export const getczxx = params => {

    return service({
        url: root + "/prdes/getczxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//线材列表
export const getline = params => {

    return service({
        url: root + "/prdes/getline",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//面板颜色
export const getmbcolor = params => {

    return service({
        url: root + "/prdes/getmbcolor",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//面板特效
export const getmbtx = params => {

    return service({
        url: root + "/prdes/getmbtx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//LOGO样式
export const getlogo = params => {

    return service({
        url: root + "/prdes/getlogo",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//保存
export const getdeurl = params => {

    return service({
        url: root + "/prdes/getdeurl",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//底部列表
export const getfooter = params => {

    return service({
        url: root + "/index/dbcdxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//底部信息
export const getfootermsg = params => {

    return service({
        url: root + "/index/webxxhq",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};


//判断登录
export const pddl = params => {

    return service({
        url: root + "/guserx/pddl",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

export const wxpdpay = params => {

    return service({
        url: root + "/pdpay/wxpdpay",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

export const gzkxx = params => {

    return service({
        url: root + "/guserx/gzkxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

export const getbanner = params => {

    return service({
        url: root + "/index/getbanner",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//获取经验值
export const getpoinxx = params => {

    return service({
        url: root + "/index/getpoinxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//设计支付
export const sjpay = params => {

    return service({
        url: root + "/prdes/prepay",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};
//判断设计支付
export const sjpayif = params => {

    return service({
        url: root + "/pdpay/dewxpdpay",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//外部订单详情
export const getotheroder = params => {

    return service({
        url: root + "/index/cpddxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//
export const getsjzfurl = params => {

    return service({
        url: root + "/index/tjdurl",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//获取保存id
export const getdeurlid = params => {

    return service({
        url: root + "/prdes/getdeurl",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

export const todeurlid = params => {

    return service({
        url: root + "/prdes/getbcxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

export const getimg = params => {

    return service({
        url: root + "/prdes/picsc",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};


// 获取地址

export const getyhaddress = params => {

    return service({
        url: root + "/index/yhaddress",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//上传图片
export const gettimg = params => {

    return service({
        url: root + "/index/ceshi",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//定制化订单查询
export const getDoder = params => {

    return service({
        url: root + "/prdes/desgxx",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};

//产品颜色
export const getPcolor = params => {

    return service({
        url: root + "/index/getcolor",
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }]
    });
};



// WEBPACK FOOTER //
// ./src/api/api.js